import { createFeatureFlagsContext } from "@packages/feature-flags";

const {
  Provider: FeatureFlagsProvider,
  useFeatureFlags,
  useExperienceString,
} = createFeatureFlagsContext();

export { FeatureFlagsProvider, useFeatureFlags, useExperienceString };
